import {UserOPEEnum} from "../UserOPEEnum";
import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";

class O {
  groups!: UserMetricGroupDTO[];

  constructor() {
    this.groups = [];
  }
}

class UserMetricGroupDTO {
  id!: number;
  name!: string;
}

/**
 * O Inner Class
 */
class I {

}


/**
 * GetTransportItemDetailCB class
 */
export class GetUserMetricGroupsCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(UserOPEEnum.GetUserMetricGroups);
    this.i = new I();
    this.o = new O();
  }

}
